<template>
    <div class="user-list">
        <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
            <el-form-item>
                <el-input v-model="filter.clueOrderId" placeholder="id" size="small"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="filter.userName" placeholder="user" size="small"></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
                <el-select  v-model="filter.status">
                    <el-option value="" label="全部"></el-option>
                    <el-option value="succ" label="成功"></el-option>
                    <el-option value="fail" label="失败"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="交易类型">
                <el-select  v-model="filter.type">
                    <el-option value="" label="全部"></el-option>
                    <el-option value="recharge" label="充值"></el-option>
                    <el-option value="pay" label="支付"></el-option>
                    <el-option value="back" label="退回"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始时间">
                <el-date-picker
                        v-model="filter.startTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        align="center"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item label="结束时间">
                <el-date-picker
                        v-model="filter.endTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        align="center"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="fetch" size="mini">查询</el-button>

                </el-button-group>
            </el-form-item>
        </el-form>

        <h3>线索卡管理</h3>
        <el-table :data="list" size="mini">
            <!--<el-table-column type="expand">-->
                <!--<template slot-scope="props">-->
                   <!--dsds-->
                <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column prop="clueOrderId" label="ID"></el-table-column>
            <el-table-column prop="accountName" label="账号名字"></el-table-column>
            <el-table-column prop="userName" label="用户"></el-table-column>
            <el-table-column prop="type" label="类型">
                <template slot-scope="scope">
                    <el-tag size="mini" type="primary" v-if="scope.row.type==='recharge'">充值</el-tag>
                    <el-tag size="mini" type="success" v-if="scope.row.type==='pay'">支付</el-tag>
                    <el-tag size="mini" type="danger" v-if="scope.row.type==='back'">退回</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="count" label="数量">
                <template slot-scope="scope">
                    <p v-if=" scope.row.type=='pay' ">-{{scope.row.count}}</p>
                    <p v-else>+{{scope.row.count}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                    <el-tag size="mini"  type="primary" v-if="scope.row.status==='succ'">成功</el-tag>
                    <el-tag size="mini"  type="danger" v-else>失败</el-tag>

                </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="时间"></el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="i=>page=i"
                    :page-size="20"
                    :page-count="page"
                    :total="total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
  import request from "../request";
  import map from "../../datamap";
  import api from '../api'
  const {clue} = api



  export default {
    name: "user-list",
    data() {
      return {
        loading: true,
        list: [],
        roles:[],
        total:0,
        page:1,
        filter:{
	        clueOrderId:"",
	        userName:'',
	        status:'',
            type:'',
	        startTime:'',
	        endTime:""
        }
      };
    },
    watch:{
      page(){
        this.fetch()
      }
    },
    methods: {
      async fetch() {
        let pageNum = this.page
        this.loading = true;

        let {clueOrderId,userName,status,type,startTime,endTime} = this.filter
	      if(startTime && endTime){
		      startTime = Date.parse(startTime)
		      endTime = Date.parse(endTime)
	      }
        if (startTime && !endTime) {
          endTime = Date.now()
          startTime = Date.parse(startTime)
        }
        let res = await clue.list({start:(pageNum-1)*20,culeOrderId:clueOrderId,userName,status,type,startTime
        ,endTime});
        this.list = res.data.data;
        this.loading = false;
        this.total = res.data.pageinfo.totalCount
      },

      async fetchUser(type,scope,id){

        let res = await user.item({userId:id})



        let {data} = res.data

      },

      async add(){
        try{
          let {value} = await this.$prompt('请输入用户名', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
          let res = await request.post(post, {
            username:value,
            password:'123456',
            locked:0,
          });
          this.fetch()
        }catch(e){
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        }
      },

      async fetch_role(){
        let res = await role.list()
        res = res.data.data.map((item) => {
          item.key = item.roleId
          item.label = item.roleName
          return item
        })
        this.roles = res
      },

      async update(obj) {
        obj.roleIds = obj.r
        let res = await request.post(update, obj);
        this.fetch();
      },

      async remove(obj){
        try{
          await this.$confirm(' 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          let res = await request.post(remove,obj)
          this.fetch()
        }catch(e){
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        }

      },

    },
    mounted() {
      this.fetch();
      this.fetch_role()
    }
  };
</script>

<style>
    .user-list {
    }
</style>



// WEBPACK FOOTER //
// src/views/order/clue.vue